import * as React from 'react';

/*
 * title - The string showed in the input afters selecting a results
 * id - The unique identifier of the object (REACTJS keys)
 * childrens are The DOM elements of the result box.
 */
export type Props = {
  title: string;
  id?: number | string;
  uuid?: string;
  approvalSettings?: { requireTeacherApproval: boolean; requireClassApproval: boolean };
};

/* Simple component to describe the structure
 * of a AsyncSelectItem, which are the things that
 * must be passed back in AsyncSelect#searchCallback.
 */
class AsyncSelectItem extends React.Component<Props> {
  render() {
    return this.props.children;
  }
}

export default AsyncSelectItem;
